<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_label">オペレーターを評価</h2>

      <p class="bold_label">1. 作業の完成度</p>
      <div>
        <input class="radio_form" type="radio" v-model="newScore.perfection" value="1" id="3_1">
        <label class="radio-label_form" for="3_1">指示通りに作図・修正されていない</label>

        <input class="radio_form" type="radio" v-model="newScore.perfection" value="2" id="3_2">
        <label class="radio-label_form" for="3_2">おおよそ指示通りに作図・修正された</label>

        <input class="radio_form" type="radio" v-model="newScore.perfection" value="3" id="3_3">
        <label class="radio-label_form" for="3_3">指示通り作図・修正された</label>

        <input class="radio_form" type="radio" v-model="newScore.perfection" value="4" id="3_4">
        <label class="radio-label_form" for="3_4">指示以外の有益な作図・指摘が多少あった</label>

        <input class="radio_form" type="radio" v-model="newScore.perfection" value="5" id="3_5">
        <label class="radio-label_form" for="3_5">指示以外の有益な作図・指摘があった</label>
      </div>

      <p class="bold_label">2. 作業の速さ</p>
      <div>
        <input class="radio_form" type="radio" v-model="newScore.speed" value="1" id="4_1">
        <label class="radio-label_form" for="4_1">遅い</label>

        <input class="radio_form" type="radio" v-model="newScore.speed" value="2" id="4_2">
        <label class="radio-label_form" for="4_2">やや遅い</label>

        <input class="radio_form" type="radio" v-model="newScore.speed" value="3" id="4_3">
        <label class="radio-label_form" for="4_3">普通</label>

        <input class="radio_form" type="radio" v-model="newScore.speed" value="4" id="4_4">
        <label class="radio-label_form" for="4_4">やや早い</label>

        <input class="radio_form" type="radio" v-model="newScore.speed" value="5" id="4_5">
        <label class="radio-label_form" for="4_5">早い</label>
      </div>

      <button class="purple-ellipse_button" @click="registerScore()">評価する</button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import collection from "@/assets/js/functions/firebase/firestore/collection.js";
  import subCollection from "@/assets/js/functions/firebase/firestore/sub_collection.js";
  import caller from '@/assets/js/functions/firebase/cloud_functions/caller.js';
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";
  import toast from "@/assets/js/functions/_core/toast";

  export default {
    name: "CreatingOperatorScore",

    mixins: [collection, subCollection, caller, toast],

    data() {
      return {
        matchingId: '',
        operator: {},
        requestScores: {},
        newScore: {
          perfection: 0,
          speed: 0,
        },
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      this.matchingId = location.pathname.replace(/^\/matching\/suf\//, '');
      this.matchingId = this.matchingId.replace(/\/score\/create\/operator\/*$/, '');

      await this.getDoc(COLLECTION_NAMES.MATCHINGS, this.matchingId).then(async matching => {
        this.matching = matching;

        // マッチングが無かった時 && クライアントではない場合
        if (!matching || !matching.client || this.matching.client.id !== this.uid) this.$router.push({name: 'MypageTop'});

        const scoreLogRef = this.subCollectionDocRef(COLLECTION_NAMES.CLIENTS, this.uid, COLLECTION_NAMES.SCORE_LOGS);
        this.getSubCollectionDocument(scoreLogRef, this.matchingId).then(async score => {
          if (score) {
            this.showSuccessMessage('既に評価済みです。');
            this.$router.push({name: 'MypageTop'});
          }
        });
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });
    },

    methods: {
      async registerScore() {
        await this.getDoc(COLLECTION_NAMES.OPERATORS, this.matching.operator.id).then(async operator => {
          this.operator = operator;
          await this.calculateScore(this.operator.scores);
          const scoreRef = this.subCollectionDocRef(COLLECTION_NAMES.OPERATORS, this.matching.operator.id, COLLECTION_NAMES.SCORE);

          await this.updateSubCollectionDocument(scoreRef, this.matching.operator.id, this.requestScores).then(() => {
            const scoreLogRef = this.subCollectionDocRef(COLLECTION_NAMES.CLIENTS, this.uid, COLLECTION_NAMES.SCORE_LOGS);

            this.createSubCollectionDocument(scoreLogRef, this.matchingId, {}).then(() => {
              this.showSuccessMessage('オペレーターを評価しました。');
              this.$router.push({name: 'MypageTop'});
            });
          });
        });
      },

      calculateScore(oldScore) {
        this.requestScores.perfection = this.recalculationAverage(oldScore.perfection, oldScore.numberOfScores, Number(this.newScore.perfection));
        this.requestScores.speed = this.recalculationAverage(oldScore.speed, oldScore.numberOfScores, Number(this.newScore.speed));
        this.requestScores.numberOfScores = oldScore.numberOfScores + 1;
        this.requestScores.total = (this.requestScores.perfection + this.requestScores.speed) / 2;
      },

      recalculationAverage(oldAve, count, score) {
        let oldTotalPoints = oldAve * count;
        let newTotalPoints = oldTotalPoints + score;
        let newAve = newTotalPoints / (count + 1);
        return newAve;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background: linear-gradient(45deg, $client_third, $client_third, $operator_secondary, $operator_secondary);

    > .contents {
      @include form-contents();

      > div {
        display: flex;
        flex-flow: column;
        width: 100%;

        > label {
          margin-top: 1rem;
        }
      }

    }
  }
</style>